import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Card from './Card';

const Api_worlds = () => {
    const [data, setData] = useState([]);
    const race = ['human', 'droid', 'wookiee', 'rodian', 'hutt', 'gungan']
    const [selectRadio, setSelectRadio] = useState('');
    const [search, setSearch] = useState("");

    // Pour la barre de recherche
    const handlesearch = (e) => {
        let handlevalue = e.target.value;
        setSearch(handlevalue);
        console.log(handlevalue);
    }


    // quand le composant est monté
    useEffect(() => {
        axios.get('https://akabab.github.io/starwars-api/api/all.json')
            .then((res) => setData(res.data))
    }, [])
    return (
        <div className='countries'>
            <form>
                <input
                    type="text"
                    placeholder="Entrez le nom d'un personnage"
                    id="search-input"
                    onChange={handlesearch}
                />
                <input type="submit" value="Rechercher" />
            </form>
            <ul className='radio-container'>
                {/* J'ai créé un tableau avec les especes pour faire un map dessus et ne pas ecrire plusieurs fois la meme chose pour chaque espèce*/}
                {race.map((espece, indexRace) => (
                    <li key={indexRace}>
                        <input

                            type='radio'
                            checked={espece === setSelectRadio}
                            // Pour qu'aucun element de la liste ne soit checked lorsqu'on fait annuler la recherche
                            id={espece}
                            name='race'
                            onChange={(e) => setSelectRadio(e.target.id)} />
                        <label htmlFor={espece}>{espece}</label>
                    </li>
                ))}
            </ul>
            {selectRadio && <button onClick={() => setSelectRadio('')}>Annuler la recherche</button>}
            {/* Pour afficher un bouton 'annuler la recherche' uniquement lorsqu'un selectRadio est checked */}
            <ul >
                {data
                    // .filter((perso) => perso.name.includes(search))
                    .filter((perso) => perso.species.includes(selectRadio))
                    .filter((perso) => perso.name.includes(search))
                    .map((perso, index) => <Card key={index} character={perso} />)
                }


            </ul>
        </div >
    );
};
export default Api_worlds;